var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"localeChangeBox",staticClass:"localeChange_box"},_vm._l((_vm.localeList),function(item){return _c('div',{key:item.value,staticClass:"localeChange_item",class:{'localeChange_item-active': _vm.curLocale === item.value},on:{"click":function($event){return _vm.changeLocale(item.value)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }